import * as React from "react";
import { Root as PrimitiveRoot } from "@radix-ui/react-checkbox";
import { Icons } from "@flash-tecnologia/hros-web-ui-v2";

import { BaseRoot, BaseIndicator } from "./checkbox.styles";

export type CheckboxSize = "sm" | "md";
export interface RootProps {
  size?: CheckboxSize;
  hasError?: boolean;
}

const Root = React.forwardRef<
  React.ElementRef<typeof PrimitiveRoot>,
  React.ComponentPropsWithoutRef<typeof PrimitiveRoot> & RootProps
>((props, forwardedRef) => <BaseRoot {...props} ref={forwardedRef} />);
Root.displayName = "CheckboxRoot";

const Indicator = React.forwardRef<
  React.ElementRef<typeof BaseIndicator>,
  React.ComponentPropsWithoutRef<typeof BaseIndicator>
>((props, forwardedRef) => <BaseIndicator {...props} ref={forwardedRef} />);
Indicator.displayName = "CheckboxIndicator";

export interface CheckboxProps
  extends RootProps,
    React.ComponentPropsWithoutRef<typeof Root> {
  children?: React.ReactNode;
  indicatorIcon?: React.ReactNode;
}

/*
 * Design specs: [Figma](https://www.figma.com/design/O8e4aYN68szCCqWvEPh5Ji/Core-Components-%E2%80%A2-Web-%E2%80%A2-Flamingo-UI-%E2%80%A2-Design-System?node-id=23417-46440&p=f)
 */

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof BaseRoot>,
  CheckboxProps
>(({ indicatorIcon, className, size = "md", ...props }, forwardedRef) => {
  const indicator = indicatorIcon || (
    <Icons name="IconCheck" size={16} color="var(--color-neutral-100)" />
  );

  return (
    <Root {...props} size={size} ref={forwardedRef} className={className}>
      <Indicator>{indicator}</Indicator>
    </Root>
  );
});
Checkbox.displayName = "Checkbox";
